import styled from 'styled-components';
import { CircularProgress } from '@mui/material';
import AppCSS from '../../utils/styled';

export const Components = {
  CircularProgress: styled(CircularProgress)`
    color: ${AppCSS.colors.utility.activityIndicator.color};
  `,
};
